import moment from 'moment';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'redu... Remove this comment to see the full error message
import { createRoutine, promisifyRoutine } from 'redux-saga-routines';
import { get } from 'lodash/fp';
import { takeLatest, put, call, select } from 'redux-saga/effects';
import api, { API_HOST } from '@whitelabel/helpers/api';
import {
  POLICY_TYPE,
  QUICKBOOKS_PARTNER_ID,
  CAMPAIGN_ID,
  INVALID_QUOTES,
  CURRENCIES,
} from '@whitelabel/helpers/constants';
export const createMultiQuotes = createRoutine('quotes/CREATE_MULTI_QUOTE');
export const SELECT_QUOTE = 'SELECT_QUOTE';
export const createMultiQuotesdPromiseRoutine = promisifyRoutine(createMultiQuotes);
function* handleCreateMultiQuote({ payload: { postcode, latitude, longitude, limits } }: any) {
  const search = yield select(get('router.location.search'));
  const urlParams = new URLSearchParams(search);
  const campaignId = urlParams.get(CAMPAIGN_ID);
  const policyStartDate = moment().add(1, 'd');
  const payload = {
    partner_code: QUICKBOOKS_PARTNER_ID,
    partner_subsidiary: 'quickbooks',
    policy_type: POLICY_TYPE.EARTHQUAKE_COVER,
    policy_start_date: policyStartDate.format(),
    policy_end_date: policyStartDate.add(1, 'y').format(),
    location_latitude: latitude,
    location_longitude: longitude,
    variable_fields: [{ coverage_limit: limits[0] }, { coverage_limit: limits[1] }, { coverage_limit: limits[2] }],
    post_code: postcode,
    currency: CURRENCIES.USD,
    country: 'US',
  };
  if (campaignId) (payload as any).partner_metadata = { campaign_id: campaignId };
  try {
    const body = JSON.stringify(payload);
    yield put(createMultiQuotes.request());
    const quotePackages = yield call(api.post, `${API_HOST}/quotes/multiple/`, false, { body });
    if (quotePackages[0].quotes[0]) {
      yield put(createMultiQuotes.success(quotePackages));
    } else {
      yield put(createMultiQuotes.failure(INVALID_QUOTES));
    }
  } catch (error) {
    yield put(createMultiQuotes.failure(error));
  } finally {
    yield put(createMultiQuotes.fulfill());
  }
}
export const selectQuote = (quoteIndex: any) => ({
  type: SELECT_QUOTE,
  payload: quoteIndex,
});
export function* multiQuotesSaga() {
  yield takeLatest(createMultiQuotes.TRIGGER, handleCreateMultiQuote);
}
